import { render, staticRenderFns } from "./MembershipTierActionButton.vue?vue&type=template&id=5df7a136&"
import script from "./MembershipTierActionButton.vue?vue&type=script&lang=ts&"
export * from "./MembershipTierActionButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports